import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneMatchListGroupPayload {
    matchListGroupId: string
}

export interface IOneMatchListGroupState {
    status: string
    data: null
    errors: any
}

const initialState: IOneMatchListGroupState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneMatchListGroup = createSlice({
    name: 'matchListGroup/one-match-list-group',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneMatchListGroupPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneMatchListGroupActions = oneMatchListGroup.actions
export default oneMatchListGroup.reducer
